import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    commits: []
};

const commitsSlice = createSlice({
    name: 'commits',
    initialState,
    reducers: {
        guardarCommits: (state, action) => {
            state.commits= action.payload;
        }
    }
});

export const { guardarCommits } = commitsSlice.actions;
export default commitsSlice.reducer;